export const AUTH_MODULE = 'auth'

// Action && Mutation
export const REQUEST_SOCIAL_LOGIN = 'requestSocialLogin'
export const REQUEST_EMAIL_LOGIN = 'requestEmailLogin'
export const EMAIL_LOGIN = 'emailLogin'
export const SET_RESET_PASSWORD_PROMPT = 'setResetPasswordPrompt'
export const SET_PASSWORD_ERROR = 'setPasswordError'
export const RESET_PASSWORD_ERROR = 'resetPasswordError'
export const SET_FORGOT_EMAIL_LOGIN = 'setForgotEmailLogin'

// Getter
export const RESET_PASSWORD_PROMPT = 'getResetPasswordPrompt'
export const PASSWORD_SERVER_ERROR = 'getPasswordError'
export const FORGOT_EMAIL_LOGIN = 'getForgotEmailLogin'
